// Countdown Timer Function
function countdown(targetDate) {
  const now = new Date().getTime(); // Get current time in milliseconds
  const timeLeft = targetDate.getTime() - now; // Calculate time difference

  if (timeLeft > 0) {
    // Calculate time components
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    // Return countdown values
    return { days, hours, minutes, seconds };
  } else {
    // If countdown ends, return zeroes
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }
}

// Get target date - 1 day from start of today, resets daily
function getTargetDate() {
  const now = new Date();
  // Get the end of today (midnight tonight)
  const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
  return endOfDay;
}

// Export the function to get the current countdown (resets every day at midnight)
export function getCountdown() {
  return countdown(getTargetDate());
}
